"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCollectionInfo = exports.isViewInfo = exports.isTableInfo = exports.isTableColumnUnique = exports.extendDatabaseInfoFromApps = exports.extendDatabaseInfo = exports.extendTableInfo = exports.addTableDependencies = void 0;
const flatten_1 = __importDefault(require("lodash/flatten"));
function addTableDependencies(db) {
    if (!db.tables) {
        return db;
    }
    const allForeignKeys = (0, flatten_1.default)(db.tables.map(x => x.foreignKeys || []));
    return Object.assign(Object.assign({}, db), { tables: db.tables.map(table => (Object.assign(Object.assign({}, table), { dependencies: allForeignKeys.filter(x => x.refSchemaName == table.schemaName && x.refTableName == table.pureName) }))) });
}
exports.addTableDependencies = addTableDependencies;
function extendTableInfo(table) {
    return Object.assign(Object.assign({}, table), { objectTypeField: 'tables', columns: (table.columns || []).map(column => (Object.assign({ pureName: table.pureName, schemaName: table.schemaName }, column))), primaryKey: table.primaryKey
            ? Object.assign(Object.assign({}, table.primaryKey), { pureName: table.pureName, schemaName: table.schemaName, constraintType: 'primaryKey' }) : undefined, foreignKeys: (table.foreignKeys || []).map(cnt => (Object.assign(Object.assign({}, cnt), { pureName: table.pureName, schemaName: table.schemaName, constraintType: 'foreignKey' }))), indexes: (table.indexes || []).map(cnt => (Object.assign(Object.assign({}, cnt), { pureName: table.pureName, schemaName: table.schemaName, constraintType: 'index' }))), checks: (table.checks || []).map(cnt => (Object.assign(Object.assign({}, cnt), { pureName: table.pureName, schemaName: table.schemaName, constraintType: 'check' }))), uniques: (table.uniques || []).map(cnt => (Object.assign(Object.assign({}, cnt), { pureName: table.pureName, schemaName: table.schemaName, constraintType: 'unique' }))) });
}
exports.extendTableInfo = extendTableInfo;
function fillDatabaseExtendedInfo(db) {
    return Object.assign(Object.assign({}, db), { tables: (db.tables || []).map(extendTableInfo), collections: (db.collections || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'collections' }))), views: (db.views || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'views' }))), matviews: (db.matviews || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'matviews' }))), procedures: (db.procedures || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'procedures' }))), functions: (db.functions || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'functions' }))), triggers: (db.triggers || []).map(obj => (Object.assign(Object.assign({}, obj), { objectTypeField: 'triggers' }))) });
}
function extendDatabaseInfo(db) {
    return fillDatabaseExtendedInfo(addTableDependencies(db));
}
exports.extendDatabaseInfo = extendDatabaseInfo;
function extendDatabaseInfoFromApps(db, apps) {
    if (!db || !apps)
        return db;
    const dbExt = Object.assign(Object.assign({}, db), { tables: db.tables.map(table => (Object.assign(Object.assign({}, table), { foreignKeys: [
                ...(table.foreignKeys || []),
                ...(0, flatten_1.default)(apps.map(app => app.virtualReferences || []))
                    .filter(fk => fk.pureName == table.pureName && fk.schemaName == table.schemaName)
                    .map(fk => (Object.assign(Object.assign({}, fk), { constraintType: 'foreignKey', isVirtual: true }))),
            ] }))) });
    return addTableDependencies(dbExt);
}
exports.extendDatabaseInfoFromApps = extendDatabaseInfoFromApps;
function isTableColumnUnique(table, column) {
    if (table.primaryKey && table.primaryKey.columns.length == 1 && table.primaryKey.columns[0].columnName == column) {
        return true;
    }
    const uqs = [...(table.uniques || []), ...(table.indexes || []).filter(x => x.isUnique)];
    if (uqs.find(uq => uq.columns.length == 1 && uq.columns[0].columnName == column)) {
        return true;
    }
    return false;
}
exports.isTableColumnUnique = isTableColumnUnique;
function isTableInfo(obj) {
    return obj.objectTypeField == 'tables';
}
exports.isTableInfo = isTableInfo;
function isViewInfo(obj) {
    return obj.objectTypeField == 'views';
}
exports.isViewInfo = isViewInfo;
function isCollectionInfo(obj) {
    return obj.objectTypeField == 'collections';
}
exports.isCollectionInfo = isCollectionInfo;
